import axios from 'axios';
import config from '../config';

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
});

let clerkSession = null;

export const setClerkSession = (session) => {
  clerkSession = session;
};

// Keep backward compat
export const setClerkTokenGetter = (getter) => {};

axiosInstance.interceptors.request.use(
  async (requestConfig) => {
    if (clerkSession) {
      try {
        const token = await clerkSession.getToken();
        if (token) {
          requestConfig.headers.Authorization = `Bearer ${token}`;
        }
      } catch (err) {
        console.error('[axios] Failed to get token:', err);
      }
    }
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
